module.exports = __webpack_public_path__ + "img/benefit-05-iot-1.2645b3f2.png";